/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

export type ScheduleTemplate = {
    /**
     * ID of a scheduled template
     *
     */
    templateId: string;
    /**
     * Type of template (needed for fetching template from GAPI)
     *
     */
    templateType: ScheduleTemplate.templateType;
};

export namespace ScheduleTemplate {

    /**
     * Type of template (needed for fetching template from GAPI)
     *
     */
    export enum templateType {
        TRANSFER = 'TRANSFER',
        DIRECT_DEBIT = 'DIRECT_DEBIT',
        TRANSFER_BULK = 'TRANSFER_BULK',
        DIRECT_DEBIT_BULK = 'DIRECT_DEBIT_BULK',
    }


}

